import { render, staticRenderFns } from "./ReviewerShop.vue?vue&type=template&id=2e71c0b2&scoped=true&"
import script from "./ReviewerShop.vue?vue&type=script&lang=js&"
export * from "./ReviewerShop.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerShop.vue?vue&type=style&index=0&id=2e71c0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e71c0b2",
  null
  
)

export default component.exports